
import { Vue, Component, Ref } from 'vue-property-decorator';
import SalesPlanFormModal from './SalesPlanFormModal.vue';
import lazyInject from '@/di';
import SupplyService from '@/services/supply.service';

@Component({
  components: {
    SalesPlanFormModal,
  },
})
export default class SalesPlanModal extends Vue {
  visible = false;

  loading = false;

  @lazyInject(SupplyService)
  supplyService!: SupplyService;

  goods: any = null;

  dataSource: any[] = [];

  columns = [
    {
      title: '销售方案名称',
      dataIndex: 'plan_name',
      align: 'center',
    },
    {
      title: '省运营中心执行价',
      dataIndex: 'agent_price',
      align: 'center',
    },
    {
      title: '地区服务商建议价',
      dataIndex: 'supplier_price',
      align: 'center',
    },
    {
      title: '门店采购建议价',
      dataIndex: 'shop_price',
      align: 'center',
    },
    {
      title: '建议零售价',
      dataIndex: 'price',
      align: 'center',
    },
    {
      title: '单位',
      dataIndex: 'unit',
      align: 'center',
    },
    {
      title: '适用经销商数',
      dataIndex: 'distributor_count',
      align: 'center',
    },
    {
      title: '状态',
      dataIndex: 'status',
      align: 'center',
      customRender: (text: any, record: any) => {
        return record.status ? '启用' : '禁用';
      },
    },
    {
      title: '创建时间',
      dataIndex: 'created_at',
      align: 'center',
    },
    {
      title: '操作',
      dataIndex: 'action',
      align: 'center',
      fixed: 'right',
      width: 160,
      scopedSlots: { customRender: 'action' },
    },
  ];

  pagination: any = {
    current: 1,
    pageSize: 10,
    total: 0,
    onChange: this.paginationChange,
  };

  open(record: any) {
    this.goods = record;
    console.log('goods', record);
    this.pagination.current = 1;
    this.visible = true;
    this.getList();
  }

  async getList() {
    // TODO: 调用销售方案列表接口，参数：this.goods、this.pagination.current
    const res = await this.supplyService.getCommodityPlanList({
      commodity_id: this.goods.id,
      page: this.pagination.current,
      pageSize: this.pagination.pageSize,
    });
    console.log('res', res);
    this.loading = false;
    this.dataSource = res.list;
    this.pagination.total = res.total;
  }

  paginationChange(page: number, pageSize: number) {
    this.pagination.current = page;
    this.pagination.pageSize = pageSize;
    this.getList();
  }

  addSalesPlan() {
    this.salesPlanFormModal.open(this.goods);
  }

  editSalesPlan(record: any) {
    this.salesPlanFormModal.open(this.goods, record);
  }

  updateStatus(record: any) {
    this.$confirm({
      title: '提示',
      content: `确认${ record.status ? '禁用' : '启用' }该销售方案吗？`,
      onOk: async () => {
        const res = await this.supplyService.postCommodityPlanUpdateStatus({
          id: record.id,
          status: record.status ? 0 : 1,
        });
        // TODO: 调用销售方案上架下架接口，参数：record
        if (res) {
          console.log(record.status ? '禁用' : '启用', record);
          this.$message.success('操作成功');
          this.getList();
        }
      },
    });
  }

  @Ref('salesPlanFormModal')
  salesPlanFormModal!: SalesPlanFormModal;

  deleteSalesPlan(record: any) {
    this.$confirm({
      title: '提示',
      content: '确认删除该销售方案吗？',
      onOk: () => {
        // TODO: 调用删除销售方案接口，参数：record
        console.log('删除销售方案', record);
        this.$message.success('删除成功');
        this.getList();
      },
    });
  }

  handleCancel() {
    this.visible = false;
  }
}
